import { render, staticRenderFns } from "./TabSwitch.vue?vue&type=template&id=ebfd4c8e&scoped=true"
import script from "./TabSwitch.vue?vue&type=script&lang=js"
export * from "./TabSwitch.vue?vue&type=script&lang=js"
import style0 from "./TabSwitch.vue?vue&type=style&index=0&id=ebfd4c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfd4c8e",
  null
  
)

export default component.exports